export type PrivateModule =
    | 'january'
    | 'february'
    | 'march'
    | 'april'
    | 'may'
    | 'june'
    | 'july'
    | 'august'
    | 'september'
    | 'october'
    | 'november'
    | 'december';

export const PRIVATE_MODULES: PrivateModule[] = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
];

export const singlePage: { [P in PrivateModule]: string[] } = {
    january: [
        'january-single-name',
        'january-active-success',
        'january-active-fail',
        'january-open-applet',
        'january-order-inquiry',
        'january-test-paper-video',
    ],
    february: [
        'february-single-name',
        'february-video-list',
        'february-middle-accounting-video',
        'february-video-list-page',
        'february-trial-class-page',
        'february-discount-coupon',
        'february-discount-coupon-50',
        'february-discount-coupon-config',
    ],
    march: ['march-information-detail', 'march-goods-detail', 'march-coupons-page'],
    april: ['april-single-name', 'april-generalization-single'],
    may: ['may-single-name'],
    june: ['june-single-name', 'june-activity-618', 'june-internal-benefits', 'june-newcomer-gift', 'june-course-collection'],
    july: ['july-single-name'],
    august: [
        'august-single-name',
        'august-app-download',
        'august-student-evaluation',
        'august-achievement-collection',
        'intermediate-achievement-collection',
        'august-video-page',
        'august-score-collection/score-collection-front',
        'august-score-collection/score-collection-form',
        'august-score-collection/score-collection-uncommitted',
        'august-score-collection/score-collection-result',
        'august-intermediate-score-collection/intermediate-score-collection-form',
        'august-intermediate-score-collection/intermediate-score-collection-uncommitted',
        'august-intermediate-score-collection/intermediate-score-collection-result',
    ],
    september: [
        'september-single-name',
        'september-privacy-agreement',
        'september-user-register-agreement',
        'september-user-logout-agreement',
    ],
    october: [
        'october-single-name',
        'october-privacy-agreement',
        'october-double-eleven',
        'october-intermediate-scoring',
        'october-test-questions',
    ],
    november: ['november-single-name', 'november-questionnaire', 'november-questionnaire-details', 'november-shop-poster'],
    december: [
        'december-teacher-interview-process',
        'december-etiquette-skills',
        'december-student-train-agreement',
        'december-double-twelve-active',
        'december-new-year-activities/december-new-year-activities-router',
        'december-new-year-coupon/december-new-year-coupon-router',
        'december-adv-share-page/december-adv-share-page',
    ],
};
